import { IWithContextProps, withContext } from '@tock/coretypes';
import { Typography } from 'omakase';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  acceptsWalkins: boolean;
  businessEmail?: string | null;
  businessName: string;
  businessPhone: string;
}

class SearchFooter extends BaseComponent<Props & IWithContextProps> {
  render() {
    const {
      acceptsWalkins,
      businessEmail,
      businessName,
      businessPhone,
      context: { isFeatureEnabled },
    } = this.props;
    const showPhoneAndEmail = isFeatureEnabled('SHOW_PHONE_AND_EMAIL_NO_RESERVATIONS');

    if (!acceptsWalkins) {
      return null;
    }

    return (
      <div className="SearchModal-footer">
        <div className="SearchModal-footerContent">
          {showPhoneAndEmail ? (
            <Typography color="inherit" component="span" variant="body02Strong">
              Not seeing what you're looking for?&nbsp;
              {businessName} also accepts walk-ins when available.
              {businessEmail && (
                <span>
                  We also welcome you to{' '}
                  <Anchor href={`mailto:${businessEmail}`}>send us an email</Anchor>{' '}
                </span>
              )}
              {businessPhone && (
                <span>
                  or call us at <Anchor href={`tel:${businessPhone}`}>{businessPhone}</Anchor>
                </span>
              )}
              .
            </Typography>
          ) : (
            <Typography color="inherit" component="span" variant="body02Strong">
              Not seeing what you're looking for?&nbsp;
              {businessName} also accepts walk-ins when available.
            </Typography>
          )}
        </div>
      </div>
    );
  }
}

export default withContext(SearchFooter);
